
<template>
    <div class="page-layout">
      <sidebar-component :active="sidebarOpened" v-if="!showSidebar"/>
      <div class="page-layout-inner">
        <header-component :openSidebar="openSidebar" :title="title" />
          <toolBar v-if="showToolbar" class="toolBar" />
          <main>
            <div class="main-content">
                <el-row class="container">
                  <transition :name="slideHorizontal">
                    <router-view></router-view>
                  </transition>
                </el-row>
            </div>
          </main>
      </div>
      <dimmer :active="obfuscatorActive" :closeSidebar="closeSidebar" />
    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Sidebar from '@/components/Sidebar.vue';
import Dimmer from '@/components/Dimmer.vue';
import ToolBar from '@/components/CollectConsent/ToolBar.vue';
import { mapActions, mapState } from 'vuex';
import Firebase from 'firebase';

export default {
  name: 'App',
  data() {
    return {
      slideHorizontal: 'slide-left',
    };
  },
  methods: {
    ...mapActions(['handleResize', 'openSidebar', 'closeSidebar']),
    logOut() {
      Firebase.auth().signOut().then(() => {
        window.location.href = '/';
      }).catch((error) => {
        console.log(error);
      });
    },
  },
  computed: {
    ...mapState({
      sidebarOpened: state => state.sidebarOpened,
      obfuscatorActive: state => state.obfuscatorActive,
      title: state => state.route.meta.title,
      showToolbar: state => state.route.meta.showCCToolbar,
      showSidebar: state => state.route.meta.showSideBar,
    }),
  },
  components: {
    'header-component': Header,
    'sidebar-component': Sidebar,
    Dimmer,
    ToolBar,
  },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.split('/').length;
      const fromDepth = from.path.split('/').length;
      this.slideHorizontal = toDepth < fromDepth ? 'slide-right' : 'slide-left';
    },
  },
};
</script>

<style lang="scss">
.page-layout {
    .toolBar {
      position: fixed;
      top: $header-height;
      z-index: 2;
      height: $toolbar-height;
      background-color: $toolbar-bgc;
      border-bottom: 2px solid #e6e6e6;
      padding: 8px 5px;
      @include privat-respond-to('xs') {
        width: 100%;
        transform: translate3d(0, 0, 0) !important;
      }
      @include privat-respond-to('sm') {
        width: 100%;
        transform: translate3d(0, 0, 0) !important;
      }
      @include privat-respond-to('lg') {
        width: calc(100% - #{$sidebar-size});
        transform: translate3d($sidebar-size, 0, 0)!important;
      }
    }
    position: absolute;
    width: 100%;
    height: 100%;
        main {
            z-index: 1;
            overflow-x: auto;
            height: 100vh;
            padding-top: 80px;
            position: absolute;
            transform-style: preserve-3d;
            will-change: transform;
            transition-property: transform;
            width: 100%;
            transform: translate3d(0, 0, 0)!important;
            @include respond-to('lg') {
                width: calc(100% - #{$sidebar-size});
                transform: translate3d($sidebar-size, 0, 0)!important;
            }
            .main-content {
                width: 100%;
                margin: 0;
                @include respond-to('sm', 'xs') {
                    margin: 5px auto;
                }
                .container {
                    margin-top: 0;
                    padding: 0 20px;
                    > div:first-child {
                        width: 100%;
                    }
                }
            }
        }
    }
</style>
